"use client";
import React from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import Image from "next/image";
import { IMAGES } from "@/lib/constants";

const AppPromoImage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={{ mt: "20px", position: "relative", width: "100%" }}>
      <Image
        src={
          isMobile ? IMAGES.appDownloadBannerMobile : IMAGES.appDownloadBanner
        }
        alt="App Promo"
        style={{ objectFit:!isMobile ?"cover" :"none" , width:'100%'}}
      />
    </Box>
  );
};

export default AppPromoImage;
